import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'

const Stopwatch: FC<BoxProps<'svg'>> = (props) => {
  const clipPathId = React.useId()

  return (
    <Box
      component="svg"
      xmlns="http://www.w3.org/2000/svg"
      width={47}
      height={53}
      viewBox="0 0 47 53"
      fill="none"
      {...props}
    >
      <defs>
        <clipPath id={clipPathId}>
          <rect width="47" height="53" fill="white" />
        </clipPath>
      </defs>
      <g clipPath={`url(#${clipPathId})`}>
        <ellipse
          cx="23.5294"
          cy="28.504"
          rx="19.5392"
          ry="19.5392"
          fill="white"
        />
        <path
          d="M28.1383 3.76705H18.8008C17.8802 3.76705 17.2227 2.97797 17.2227 2.18888C17.2227 1.3998 18.0117 0.610718 18.8008 0.610718H28.1383C29.0589 0.610718 29.7165 1.3998 29.7165 2.18888C29.7165 2.97797 28.9274 3.76705 28.1383 3.76705Z"
          fill="#002677"
        />
        <path
          d="M25.5081 2.05699H21.4312V9.02722H25.5081V2.05699Z"
          fill="#002677"
        />
        <path
          d="M23.2724 51.9006C10.7786 51.9006 0.520508 41.6425 0.520508 29.1487C0.520508 16.6549 10.7786 6.39686 23.2724 6.39686C35.7662 6.39686 46.0243 16.6549 46.0243 29.1487C46.0243 41.6425 35.7662 51.9006 23.2724 51.9006ZM23.2724 11.6574C13.6719 11.6574 5.78106 19.5482 5.78106 29.1487C5.78106 38.7492 13.6719 46.6401 23.2724 46.6401C32.8729 46.6401 40.7637 38.7492 40.7637 29.1487C40.7637 19.5482 32.8729 11.6574 23.2724 11.6574Z"
          fill="#FF612B"
        />
        <path
          d="M38.6594 29.1489H23.4038V13.8933C31.8207 13.8933 38.6594 20.732 38.6594 29.1489Z"
          fill="#002677"
        />
      </g>
    </Box>
  )
}
export default Stopwatch
